import React, { useEffect, useState, useCallback, useRef } from "react";
import TableWrapper from "../../../core/BaseComponents/TableWrapper/TableWrapper";
// import GlobalProps from "../../../core/BaseComponents/TableWrapper/Global";
import { Link, useNavigate } from "react-router-dom";
import { MdModeEditOutline } from "react-icons/md";
import { Tooltip } from "@mui/material";
import { callAPI } from "../../../../axios";
import PropTypes from "prop-types";
import Search from "../../../core/BaseComponents/Search";
import { debounce } from 'lodash';
import DeleteIcon from "@mui/icons-material/Delete";
import deleteImg from '../../../../assets/images/delete.png';
import BasicModal from "../../../core/BaseComponents/Modal";
import dayjs from "dayjs";
import Custom_Paingation from "../../../core/BaseComponents/Custom_Paingation";
import { getUserRoleCodeFromStorage } from "../../../../utils/utils";


// const DEFAULT_PAGE_OPTION = GlobalProps.DEFAULT_PAGE_OPTION;

const RolesList = () => {
    const navigate = useNavigate();
    const recordsPerPage = 10;

    // const [pageOptions, setPageOptions] = useState(DEFAULT_PAGE_OPTION);
    const [roleList, setRoleList] = useState({});
    const [deleteRolePopUp, setDeleteRolePopUp] = useState(false);
    const loggedUserRole = getUserRoleCodeFromStorage();

    const [searchText, setSearchText] = useState("")
    const [selectedPage, setSelectedPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(1);
    const [paginationError, setPaginationError] = useState("")
    const [inputPageValue, setInputPageValue]  =useState(1)

    const isRoleDeletedRef = useRef({
        isRoleDeletedModalData: null,
        userConformationModalData: null,
    });


    const deleteRolePopUpHandler = (row) => {
        setDeleteRolePopUp(true);
        const newModalRefData = {
            isRoleDeletedModalData: {
                id: row
            },
            userConformationModalData: null,
        };
        isRoleDeletedRef.current = newModalRefData;
    }

    const deleteRoleHandler = () => {
        const { id } = isRoleDeletedRef.current?.isRoleDeletedModalData;
        callAPI(`role?sid=${id}`, "DELETE")
            .then((response) => {
                let successMessage = response.message
                const newModalRefData = {
                    isRoleDeletedModalData: null,
                    userConformationModalData: {
                        successMessage
                    },
                };
                isRoleDeletedRef.current = newModalRefData;
                roleListApi()
            })
            .catch((error) => {
                console.warn(error)
            });
    }

    const renderActionIcon = (row) => {
        return (
            <>
                {
                    row.roleCode !== "ROLE_SUPER_ADMIN" ? row.roleCode !== loggedUserRole ? <Tooltip title="Edit" arrow>
                        <MdModeEditOutline
                            className="edit-icon-enable"
                            onClick={() => navigate('/hms/edit-role', { state: { id: row.id, isEditRole: true } })}
                        />
                    </Tooltip> : <Tooltip title="" arrow>
                        <MdModeEditOutline className="edit-icon-disable" />
                    </Tooltip> : <Tooltip title="" arrow>
                        <MdModeEditOutline className="edit-icon-disable" />
                    </Tooltip>
                }
                {row.roleCode !== "ROLE_SUPER_ADMIN" ? (row.roleCode !== loggedUserRole ? (<Tooltip title="Delete" className="cursor-pointer" arrow>
                    <DeleteIcon
                        className="delete-icon-enable"
                        onClick={() => {
                            deleteRolePopUpHandler(row.id);
                        }}
                    />
                </Tooltip>) : <Tooltip title="" arrow>
                    <DeleteIcon className="delete-icon-disable" />
                </Tooltip>) : <Tooltip title="" arrow>
                    <DeleteIcon className="delete-icon-disable" />
                </Tooltip>}
            </>
        );
    };

    //For Rendering Permission Icon
    const renderPermissionsIcon = (row) => {
        return (
            <div className="roles-permissions">
                {row?.roleCode !== "ROLE_SUPER_ADMIN" ? (row?.roleCode !== loggedUserRole ? (row?.active ? (
                    <Tooltip title="Permissions" arrow>
                        <span
                            onClick={() => navigate('/hms/rolesPermissions', { state: { roleSelected: row.id } })}
                            className="icon permission-active"
                        >
                            PERMISSIONS
                        </span>
                    </Tooltip>
                ) : (
                    <Tooltip title="" arrow>
                        <span className="permission-inactive">
                            PERMISSIONS
                        </span>
                    </Tooltip>
                )) :
                    <Tooltip title="" arrow>
                        <span className="permission-inactive">
                            PERMISSIONS
                        </span>
                    </Tooltip>) : <Tooltip title="" arrow>
                    <span className="permission-inactive">
                        PERMISSIONS
                    </span>
                </Tooltip>}
            </div>
        );
    };

    const columns = [
        { field: "createdDate", headerName: "Date & Time", flex: 1, row: true, renderCell: (row)=> <p className="mb-0">{dayjs(row.createdDate).format("DD MMM YYYY | HH:mm")}</p> },
        { field: "role", headerName: "Role", flex: 1 },
        { field: "roleCode", headerName: "Role Code", flex: 1 },
        {
            field: "Status", headerName: "Status", row: true, flex: 1, sortDirection: false, disableSortIcon: true,
            renderCell: (row) => <Tooltip title={row?.active ? "Active" : "Inactive"} arrow>
                <label className={`${row?.active ? "useractive" : "userdeactive"}`}>{row?.active ? "Active" : "Inactive"}</label>
            </Tooltip>,
        },
        {
            field: "Permissions", headerName: "Permissions", flex: 1, sortDirection: false, disableSortIcon: true,
            row: true,
            renderCell: renderPermissionsIcon
        },
        {
            field: "Actions",
            row: true,
            headerName: "Edit & Delete",
            flex: 0.5,
            renderCell: renderActionIcon,
            sortDirection: false,
            disableSortIcon: true,
        },
    ];

    const roleListApi = () => {
        const apiPath = `role/search?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`;
        callAPI(apiPath, "POST", { freeText: searchText })
            .then(response => {
                setRoleList(response)
                setTotalPageCount(response?.totalPages?response?.totalPages:1)
                setPaginationError("")
    })
            .catch(err => console.warn(err.message));
    }

    useEffect(() => {
        roleListApi()
    }, [selectedPage, searchText]);

    // const setPage = (_, newPage) => {
    //     setPageOptions(prev => ({
    //         ...prev,
    //         recordsPerPage: recordData,
    //         pageSize: recordData,
    //         pageNo: newPage + 1,
    //     }));
    // };

    // const handleSelectedPerPage = (data) => {
    //     setPageOptions(prev => ({
    //         ...DEFAULT_PAGE_OPTION,
    //         recordsPerPage: data,
    //         pageSize: data,
    //         filter: prev.filter,
    //     }));
    // };

    const handleSearch = (search) => {
        setSearchText(search)
    };

    // Delay search by 600ms
    const delayedSearch = useCallback(
        debounce((searchText) => handleSearch(searchText), 600),
        []
    );

    const popupCloseHandler = () => {
        setDeleteRolePopUp(false);
    };

     //Pagination Handle changer
    const onPageChange = (event, value) => {
        setInputPageValue(value)
        setPaginationError("")
        setSelectedPage(value);
    };

    return (
        <div className="row-header">
            <div className="breadcrumb">
                <ul>
                    <li>
                        <Link to='/hms/ConfigurationNewHotel'>Dashboard </Link> <span className="arrow-color"> &gt; </span>
                    </li>
                    <li>Roles</li>
                </ul>
            </div>

            <div className="sub-header">
                <h1>Roles({roleList?.data?.totalCount})</h1>
                <div className="sub-header-right">
                    <Link to='/hms/create-role' className="sub-header_create-user">Add Role</Link>
                    <Search
                        placeholder={"Search Role..."}
                        handleSearch={delayedSearch}
                        searchText = {searchText}
                    />
                </div>
            </div>

            <TableWrapper
                data={roleList?.data?.roles}
                columns={columns}
                // rowCount={roleList?.data?.totalCount}
                // selectedPerPage={handleSelectedPerPage}
                // onPageChange={setPage}
                module={"rolesList"}
                // {...pageOptions}
                noPagination= {true}
            />
            <Custom_Paingation
                selectedPage={selectedPage}
                totalPageCount={totalPageCount}
                paginationError={paginationError}
                inputPageValue={inputPageValue}
                setSelectedPage={setSelectedPage}
                setPaginationError={setPaginationError}
                setInputPageValue={setInputPageValue}
                onPageChange={onPageChange}
            />
            <BasicModal
                popupOpen={deleteRolePopUp}
                bodyMessage={<>
                    <img src={deleteImg} alt="approve" className="w-40px" />
                    <p>{isRoleDeletedRef.current?.isRoleDeletedModalData ? "Do you really want to Delete Role ?" : isRoleDeletedRef.current?.userConformationModalData?.successMessage}</p>
                </>
                }
                footer={
                    isRoleDeletedRef.current?.isRoleDeletedModalData ?
                        {
                            primaryButton: {
                                buttonName: "Cancel",
                                action: popupCloseHandler
                            }
                            ,
                            secondaryButton: {
                                buttonName: "Delete",
                                action: deleteRoleHandler
                            }
                        } : {
                            primaryButton: {
                                buttonName: "Close",
                                action: popupCloseHandler
                            }
                        }
                }
            />
        </div>
    );
};

RolesList.propTypes = {
    moduleType: PropTypes.string,
};

export default RolesList;